/**
 * Custom JavaScript for Retrospillkongen.
 * Theme hooks available: document events 'variant:changed', 'product:added', and
 * 'cart:refresh' (dispatch on document.documentElement to re-render the mini-cart).
 */

const observer = new MutationObserver(() => {
  document.querySelectorAll(".jdgm-prev-badge__text").forEach((el) => {
    if (/reviews?/i.test(el.textContent)) {
      el.textContent = el.textContent.replace(/reviews?/gi, "").trim();
    }
  });
});
observer.observe(document.body, { childList: true, subtree: true });

document.addEventListener("DOMContentLoaded", () => {
  function handleClickAndScroll() {
    const buttonToClick = document.querySelector("#judgebutton > span.plus-button.plus-button--large");
    if (buttonToClick) {
      buttonToClick.click();
      buttonToClick.scrollIntoView({ behavior: "smooth" });
    }
  }
  const jdgmPrevBadge = document.querySelector(".jdgm-prev-badge");

  if (jdgmPrevBadge) {
    jdgmPrevBadge.addEventListener("click", handleClickAndScroll);
  }
});

window.addEventListener("load", (event) => {
  if (window.location.search.includes("judgeme_token")) {
    document.querySelector("#judgebutton").click();
    revTabInterval = setInterval(function () {
      jdgm._openReviewTab();
      jdgm.openForm(jdgm.visibleRevWidget());
      jdgm._appendCustomForm(jdgm.visibleRevWidget());
      jdgm._scrollDownToWidget();

      var observer = new IntersectionObserver(
        function (entries) {
          if (entries[0].isIntersecting === true) clearInterval(revTabInterval);
        },
        { threshold: [0] },
      );
      observer.observe(document.querySelector("#judgeme_product_reviews"));
    }, 1000);
  }
  if (window.location.hash === "#judgeme_product_reviews") {
    document.querySelector("#judgebutton").click();
  }
});

/**
 * Handlekurv-anbefalinger ("Du vil kanskje ogsaa like") i mini-cart-slideren.
 * Web-component som henter komplementaerprodukter (fallback: relaterte) via Shopify
 * sitt anbefalings-endepunkt og fyller inn seksjonen cart-recommendations.liquid.
 * connectedCallback kjoerer hver gang mini-cart re-renders, saa den holder seg oppdatert.
 */
(function () {
  if (!window.customElements || customElements.get("cart-recommendations")) return;

  class CartRecommendations extends HTMLElement {
    connectedCallback() {
      var productId = this.getAttribute("product-id");
      if (!productId || this.dataset.loaded) return;
      this.dataset.loaded = "1";
      this._load(productId);
    }

    _url(productId, intent) {
      var base = (window.routes && window.routes.rootUrlWithoutSlash) || "";
      return (
        base +
        "/recommendations/products?product_id=" +
        encodeURIComponent(productId) +
        "&limit=10&intent=" +
        intent +
        "&section_id=cart-recommendations"
      );
    }

    _extract(html) {
      var doc = new DOMParser().parseFromString(html, "text/html");
      var el = doc.querySelector(".mini-cart-recs");
      return el && el.querySelector(".product-item") ? el : null;
    }

    _load(productId) {
      var self = this;
      fetch(this._url(productId, "complementary"))
        .then(function (r) {
          return r.text();
        })
        .then(function (html) {
          var el = self._extract(html);
          if (el) {
            self.appendChild(el);
            self._wireArrows();
            return;
          }
          return fetch(self._url(productId, "related"))
            .then(function (r) {
              return r.text();
            })
            .then(function (html2) {
              var el2 = self._extract(html2);
              if (el2) {
                self.appendChild(el2);
                self._wireArrows();
              }
            });
        })
        .catch(function () {});
    }

    _wireArrows() {
      var scroller = this.querySelector("[data-cart-recs-scroller]");
      var prev = this.querySelector("[data-cart-recs-prev]");
      var next = this.querySelector("[data-cart-recs-next]");
      if (!scroller) return;

      function step() {
        // Én "side" = de 3 synlige kortene
        return scroller.clientWidth;
      }
      if (prev) {
        prev.addEventListener("click", function () {
          scroller.scrollBy({ left: -step(), behavior: "smooth" });
        });
      }
      if (next) {
        next.addEventListener("click", function () {
          scroller.scrollBy({ left: step(), behavior: "smooth" });
        });
      }

      function update() {
        var max = scroller.scrollWidth - scroller.clientWidth - 2;
        if (prev) prev.hidden = scroller.scrollLeft <= 2;
        if (next) next.hidden = scroller.scrollLeft >= max;
      }
      scroller.addEventListener("scroll", update, { passive: true });
      update();
    }
  }

  customElements.define("cart-recommendations", CartRecommendations);
})();
